import React, { useContext, useState, useEffect } from 'react';
import {
  Row, Col, Avatar, message, Empty, notification, Divider,
} from 'antd';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { sortBy } from 'lodash';
import { AuthContext } from '../../../../appContext';
import { GET_ME, GET_STUDENT_ACTIVITIES } from '../../../../graphql';
import { CohortSubjectItem } from '../common';
import { studentCohortPath, LOGIN } from '../../../../routes';
import ViewSpinner from '../../../../components/viewSpinner/ViewSpinner';
import ActivityCard from '../../common/ActivityCard';
import './styles.less';

const Landing = () => {
  const { revokeAuth } = useContext(AuthContext);
  // `me`, not a query taking an id: `user(id:)` is administrators only, so a
  // learner asking for their own record that way is refused.
  const { data: userPayload, loading, error } = useQuery(GET_ME);
  const { data: activityPayload, loading: activityLoading } = useQuery(GET_STUDENT_ACTIVITIES);
  const navigate = useNavigate();
  const [userCohort, setUserCohort] = useState([]);
  const [userDetail, setUserDetail] = useState(null);
  const [activities, setActivities] = useState({
    onlineClass: [],
    assignment: [],
  });
  useEffect(() => {
    if (!activityLoading && activityPayload) {
      const sorted = sortBy(activityPayload.myActivities, [(value) => value.activity.dueDate]);
      const firstSix = [...sorted].reverse().slice(0, 6);
      const onlineClass = firstSix.filter(({ activity: { type } }) => type === 'ONLINE_CLASS');
      const assignment = firstSix.filter(({ activity: { type } }) => type === 'ASSIGNMENT');
      setActivities({ onlineClass, assignment });
    }
  }, [activityPayload, activityLoading]);
  useEffect(() => {
    if (!loading && userPayload) {
      if (!userPayload.me.profileStudent) {
        revokeAuth();
        notification.info({
          message: 'Account creation was not complete',
          description: 'Please contact your teacher',
        });
        return navigate(LOGIN);
      }
      const {
        me: {
          cohorts, firstName, lastName, profileStudent: { profileImg },
        },
      } = userPayload;
      setUserCohort(cohorts);
      setUserDetail({ firstName, lastName, profileImg });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPayload, loading]);
  if (error) {
    message.error('Could not load cohorts');
    return <></>;
  }
  return (
    <div>
      <Row className="header">
        {userDetail && (
        <Col span={24} className="header-wrapper">
          <h3 className="ic-ft-bubble">
            Welcome!
            {' '}
            <span>{`${userDetail.firstName} ${userDetail.lastName}`}</span>
          </h3>
          <div className="avatar-wrapper">
            <Avatar src={userDetail.profileImg} size="large" className="student-avatar" />
          </div>
        </Col>
        )}
      </Row>
      {!loading && !error ? (
        <>
          <Row className="cohort-wrapper">
            <Col span={24}>
              <h4 className="ic-ft-dosis title">My Cohorts</h4>
            </Col>
            {userCohort.map(({ id, name }) => (
              <CohortSubjectItem
                extras="click continue to see lesson notes"
                key={id}
                title={name}
                link={studentCohortPath(id)}
                btnText="Continue"
              />
            ))}
          </Row>
          <Row className="recent-activity">
            <Col span={24}>
              <h4 className="ic-ft-dosis title">Recent Activities</h4>
            </Col>
          </Row>
          <Row className="gx-mt-1">
            <Divider className="gx-mb-4" orientation="left">Online Classes</Divider>
            {activities.onlineClass.map((
              {
                activityId, status, activity: { title, dueDate, type }, submission,
              },
            ) => (
              <ActivityCard
                activityId={activityId}
                type={type}
                key={activityId}
                submission={submission}
                status={status}
                date={dueDate}
                title={title}
              />
            ))}
            {!activityLoading && activities.onlineClass.length === 0 && (
              <Col span={24}>
                <Empty description="You don't have any online class yet" />
              </Col>
            )}
          </Row>
          <Row className="gx-mb-2">
            <Divider className="gx-mb-4" orientation="left">Assignments</Divider>
            {activities.assignment.map((
              {
                activityId, status, activity: { title, dueDate, type }, submission,
              },
            ) => (
              <ActivityCard
                activityId={activityId}
                type={type}
                key={activityId}
                submission={submission}
                status={status}
                date={dueDate}
                title={title}
              />
            ))}
            {!activityLoading && activities.assignment.length === 0 && (
              <Col span={24}>
                <Empty description="You don't have any assignment yet" />
              </Col>
            )}
          </Row>
        </>
      ) : <ViewSpinner />}
    </div>
  );
};

export default Landing;
